// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.news[data-v-ee7c8746] {\n\twidth: 100%;\n\ttext-align: left;\n\tfont-size: 14px;\n\tborder-bottom: solid 1px #eeeeee;\n\tpadding: 15px 10px;\n}\n.thumbnail[data-v-ee7c8746] {\n\twidth: 100px;\n\theight: 100px;\n\tmargin-right: 15px;\n\tfloat: left;\n\tbackground-color: #eeeeee;\n\tbackground-image: url(\"https://kp4cd.org/sites/default/files/images/news.svg\");\n\tborder-radius: 5px;\n\tborder: solid 1px #ccc;\n\toverflow: hidden;\n\ttext-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
